import type { WorkspaceRow } from '@/types/api'
import { api } from '@/lib/api'

/** Что показывать в превью тикета в списке обращений. */
export type TicketPreviewMode = 'summary' | 'messages'

export const WORKSPACE_TICKET_PREVIEW_MODE_CHANGED = 'workspace-ticket-preview-mode-changed'

const LS_KEY = 'servicedesk.workspace.ticketPreviewMode'

export const FALLBACK_TICKET_PREVIEW_MODE: TicketPreviewMode = 'summary'

function normalizeMode(raw: unknown): TicketPreviewMode {
  return raw === 'messages' ? 'messages' : 'summary'
}

export function ticketPreviewModeFromRow(
  ws: Pick<WorkspaceRow, 'ticket_preview_mode'> | null | undefined,
): TicketPreviewMode {
  if (!ws) return FALLBACK_TICKET_PREVIEW_MODE
  return normalizeMode(ws.ticket_preview_mode)
}

/** Синхронное чтение текущего режима из кэша (для формирования превью на лету). */
export function getCachedTicketPreviewMode(): TicketPreviewMode {
  try {
    return normalizeMode(localStorage.getItem(LS_KEY))
  } catch {
    return FALLBACK_TICKET_PREVIEW_MODE
  }
}

export function writeCachedTicketPreviewMode(mode: TicketPreviewMode): void {
  try {
    localStorage.setItem(LS_KEY, mode)
  } catch {
    /* ignore quota / private mode */
  }
  window.dispatchEvent(new CustomEvent(WORKSPACE_TICKET_PREVIEW_MODE_CHANGED))
}

export function applyTicketPreviewModeFromRow(ws: WorkspaceRow): TicketPreviewMode {
  const mode = ticketPreviewModeFromRow(ws)
  writeCachedTicketPreviewMode(mode)
  return mode
}

export async function refreshTicketPreviewModeFromApi(): Promise<TicketPreviewMode> {
  const ws = await api.workspaceMe()
  return applyTicketPreviewModeFromRow(ws)
}
